const root = "SEOLinks-module_root_xmwqBdVB";
const section = "SEOLinks-module_section_ZS6hfC1b";
const heading = "SEOLinks-module_heading_lkmyXY66";
const list = "SEOLinks-module_list_tOP7lk2U";
const link = "SEOLinks-module_link_-kz98kga";
const button = "SEOLinks-module_button_yH-lAL9q";
const styles = {
  root,
  section,
  heading,
  list,
  link,
  button
};
export {
  button,
  styles as default,
  heading,
  link,
  list,
  root,
  section
};
